module.exports = __webpack_public_path__ + "img/title-1.39acfb14.png";